import { render, staticRenderFns } from "./productLink.vue?vue&type=template&id=3ec92d40&scoped=true"
import script from "./productLink.vue?vue&type=script&lang=js"
export * from "./productLink.vue?vue&type=script&lang=js"
import style0 from "./productLink.vue?vue&type=style&index=0&id=3ec92d40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec92d40",
  null
  
)

export default component.exports